export default {
    namespaced: true,
    state: {
        obj: {},
        objs: []
    },
    mutations: {
        setObjs(state, pload) {
            state.objs = pload
        },
        setObj(state, pload) {
            state.obj = pload
        },
    },
    actions: {
        getObjs({rootState, commit}, {outlet_code, start_date, end_date, size}) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}purchase-orders?outlet=${outlet_code}&start_date=${start_date}&end_date=${end_date}&size=${size}`
                this._vm.$axios.get(url,{headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        commit('setObjs', response.data.data)
                        resolve(response.data.data)
                    }, error => {
                        reject(error)
                    })
            })
        },
        postObj({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "purchase-orders"
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    })
            })
        },
        postObjAdditional({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "purchase-orders-additional"
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    })
            })
        },
        getDetailPOAdditional({rootState}, {outletcode, date}) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}purchase-orders-additional?outlet=${outletcode}&date=${date}`
                this._vm.$axios.get(url,{headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    })
            })
        },
        getExistPO({rootState}, {outletcode, date}) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}purchase-orders-exist?outlet=${outletcode}&date=${date}`
                this._vm.$axios.get(url, { headers: { 'Authorization': 'Bearer ' + rootState.token, 'Content-Type': 'application/json' } })
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    })
            })
        },
    }
}